import './ComingSoonCard.css';

interface ComingSoonCardProps {
  icon: string;
  title: string;
  description: string;
  subscribeAnchor?: string;
}

export function ComingSoonCard({ icon, title, description, subscribeAnchor }: ComingSoonCardProps) {
  return (
    <div className="coming-soon-card">
      <div className="coming-soon-card__icon">
        <i className={icon}></i>
      </div>
      <h3 className="coming-soon-card__title">{title}</h3>
      <p className="coming-soon-card__description">{description}</p>
      {subscribeAnchor && (
        <a href={`#${subscribeAnchor}`} className="coming-soon-card__link">
          Get updates <i className="fas fa-arrow-down"></i>
        </a>
      )}
    </div>
  );
}
